export const blockIconsCommonactionsManageAccountsNew = (
	<span className='material-symbols-outlined'>manage_accounts</span>
);
